import { createReducer, on } from '@ngrx/store';
import * as formSateActions from '../actions/form-state.actions';
import { Alert } from './../../formState/model/alert';

export interface State {
  isSaved: boolean;
  alert: Alert;
}

const initialState: State = {
  isSaved: false,
  alert: null
};

export const reducer = createReducer(
  initialState,
  on(formSateActions.FormSaved, (state, action) => ({
    ...state,
    isSaved : true,
  })),
  on(formSateActions.FormReset, (state, action) => ({
    ...state,
    isSaved: false,
    alert: null,
  })),
  on(formSateActions.FormSetAlert, (state, action) => ({
    ...state,
    alert: action.alert,
  })),
  on(formSateActions.FormClearAlert, (state, action) => ({
    ...state,
    alert: null,
  })),
);
